import { useMemo } from 'react';

import type { ComponentPageData, NormalizedContentUnit } from '@/features/content/useComponent';
import type { UserRole } from '@/features/courses/useCourse';

function hasTextUnits(sections: ComponentPageData['sections'] | undefined) {
  return (
    sections?.some((section) =>
      section.units.some((unit: NormalizedContentUnit) => unit.kind === 'text'),
    ) ?? false
  );
}

export function getIsAnnotationAvailable(
  component: ComponentPageData | null | undefined,
  role: UserRole | null | undefined,
  isEditMode = false,
) {
  if (isEditMode) {
    return false;
  }

  return (
    (role === 'student' || role === 'instructor') &&
    Boolean(component) &&
    hasTextUnits(component?.sections)
  );
}

export function useAnnotationAvailability(
  component: ComponentPageData | null | undefined,
  role: UserRole | null | undefined,
  isEditMode = false,
) {
  return useMemo(
    () => getIsAnnotationAvailable(component, role, isEditMode),
    [component, isEditMode, role],
  );
}
